import authAxios from 'src/modules/shared/axios/authAxios';

export default class GoogleCalendarService {
  static async getConnectUrl() {
    const response = await authAxios.get('/auth/google-calendar/connect');
    return response.data;
  }

  static async handleCallback(code: string, state?: string) {
    const response = await authAxios.get(
      `/auth/google-calendar/callback?code=${encodeURIComponent(code)}${state ? `&state=${encodeURIComponent(state)}` : ''}`,
    );
    return response.data;
  }

  static async disconnect() {
    const response = await authAxios.post('/auth/google-calendar/disconnect');
    return response.data;
  }

  static async checkCalendarAccess() {
    try {
      // This would be implemented if you have an endpoint to check calendar access
      const response = await authAxios.get('/auth/me');
      return response.data.googleScopes?.includes('https://www.googleapis.com/auth/calendar');
    } catch (error) {
      return false;
    }
  }
}
